/** 品质系统 **/
import Layout from "@/views/layout/Layout";
const crmRouter = {
  path: "/crm",
  component: Layout,
  name: "crm",
  meta: {
    title: "CRM",
    icon: "crm",
    roles: ["CRM"]
  },
  alwaysShow: true,
  children: [
    {
      path: "basicSetting",
      component: () => import("@/views/crm/basicSetting/index"),
      meta: {
        title: "基础设置",
        roles: ["crmjichushezhi"]
      },
      alwaysShow: true,
      children: [
        {
          path: "defaultShare",
          component: () => import("@/views/crm/basicSetting/defaultShare"),
          name: "默认共享设置",
          meta: {
            title: "默认共享设置",
            roles: ["crmmorengongxiangshezhi"]
          },

          children: []
        },
        {
          path: "authority",
          component: () => import("@/views/crm/basicSetting/authority"),
          name: "客户权限设置",
          meta: {
            title: "客户权限设置",
            roles: ["crmkehuquanxianshezhi"]
          },
          children: []
        },
        {
          path: "profession",
          component: () => import("@/views/crm/basicSetting/profession"),
          name: "业务管理设置",
          meta: {
            title: "业务管理设置",
            roles: ["crmyewuguanlishezhi"]
          },
          children: []
        },
        {
          path: "customerBase",
          component: () => import("@/views/crm/basicSetting/customerBase"),
          name: "客户基础信息表维护",
          meta: {
            title: "客户基础信息表维护",
            roles: ["crmkehujichuxinxibiaoweihu"]
          },
          children: []
        },
        {
          path: "researchPlan",
          component: () => import("@/views/crm/basicSetting/researchPlan"),
          name: "调研方案信息表维护",
          meta: {
            title: "调研方案信息表维护",
            roles: ["crmdiaoyanfanganxinxibiaoweihu"]
          },
          children: []
        }
      ]
    },
    {
      path: "fileManage",
      component: () => import("@/views/crm/fileManage/index"),
      meta: {
        title: "基础档案管理",
        roles: ["crmjichudanganguanli"]
      },
      alwaysShow: true,
      children: [
        {
          path: "groupMan",
          component: () => import("@/views/crm/fileManage/groupMan"),
          name: "小组管理",
          meta: {
            title: "小组管理",
            roles: ["crmxiaozuguanli"]
          },
          children: []
        },
        {
          path: "customerFile",
          component: () => import("@/views/crm/fileManage/customerFile/index"),
          name: "客户档案管理",
          meta: {
            title: "客户档案管理",
            roles: ["crmkehudanganguanli"],
            keepAlive: true
          },
          children: []
        },
        {
          path: "contactPer",
          component: () => import("@/views/crm/fileManage/contactPer"),
          name: "联系人管理",
          meta: {
            title: "联系人管理",
            roles: ["crmlianxirenguanli"]
          },
          children: []
        },
        {
          path: "productFile",
          component: () => import("@/views/crm/fileManage/productFile"),
          name: "产品档案管理",
          meta: {
            title: "产品档案管理",
            roles: ["crmchanpindanganguanli"]
          },
          children: []
        }
      ]
    },
    {
      path: "opportunityMan",
      component: () => import("@/views/crm/opportunityMan/index"),
      meta: {
        title: "商机管理",
        roles: ["shangjiguanli"] // 之前的 crmshangjiguanli
      },
      alwaysShow: true,
      children: [
        {
          path: "advisory",
          component: () => import("@/views/crm/opportunityMan/advisory"),
          name: "咨询跟进",
          meta: {
            title: "咨询跟进",
            roles: ["crmzixungenjin"]
          },
          children: []
        },
        {
          path: "customerHighSeas",
          component: () =>
            import("@/views/crm/opportunityMan/customerHighSeas"),
          name: "客户公海",
          meta: {
            title: "客户公海",
            roles: ["crmkehugonghai"]
          },
          children: []
        },
        {
          path: "newCustomer",
          component: () => import("@/views/crm/opportunityMan/newCustomer"),
          name: "新建客户",
          meta: {
            title: "新建客户",
            roles: ["crmxinjiankehu"]
          },
          children: []
        },
        {
          path: "newBusiness",
          component: () => import("@/views/crm/opportunityMan/newBusiness"),
          name: "新建商机",
          meta: {
            title: "新建商机",
            roles: ["crmxinjianshangji"]
          },
          children: []
        },
        {
          path: "myBusiness",
          component: () => import("@/views/crm/opportunityMan/myBusiness"),
          name: "我的商机",
          meta: {
            title: "我的商机",
            roles: ["crmwodeshangji"]
          },
          children: []
        },
        {
          path: "businessMan",
          component: () => import("@/views/crm/opportunityMan/businessMan"),
          name: "商机管理",
          meta: {
            title: "商机管理",
            // shangjiguanli_web
            roles: ["shangjiguanli_web"]
          },
          children: []
        },
        {
          path: "myFollowPlan",
          component: () => import("@/views/crm/opportunityMan/myFollowPlan"),
          name: "我的跟进计划",
          meta: {
            title: "我的跟进计划",
            // shangjiguanli_web
            roles: ["wodegenjinjihua"]
          },
          children: []
        }
      ]
    },
    {
      path: "contractMan",
      component: () => import("@/views/crm/contractMan/index"),
      meta: {
        title: "合同管理",
        roles: ["crmhetongguanli"]
      },
      alwaysShow: true,
      children: [
        {
          path: "newContract",
          component: () => import("@/views/crm/contractMan/newContract"),
          name: "新建销售合同",
          meta: {
            title: "新建销售合同",
            roles: ["crmxinjianxiaoshouhetong"]
          },
          children: []
        },
        {
          path: "salesMan",
          component: () => import("@/views/crm/contractMan/salesMan"),
          name: "销售合同管理",
          meta: {
            title: "销售合同管理",
            roles: ["crmxiaoshouhetongguanli"]
          },
          children: []
        },
        {
          path: "draftMan",
          component: () => import("@/views/crm/contractMan/draftMan"),
          name: "合同草稿管理",
          meta: {
            title: "合同草稿管理",
            roles: ["crmxiaoshouhetongguanli"]
          },
          children: []
        },
        {
          path: "borrowMan",
          component: () => import("@/views/crm/contractMan/borrowMan"),
          name: "合同借阅管理",
          meta: {
            title: "合同借阅管理",
            roles: ["crmhetongjieyueguanli"]
          },
          children: []
        },
        {
          path: "templateMan",
          component: () => import("@/views/crm/contractMan/templateMan"),
          name: "合同范本管理",
          meta: {
            title: "合同范本管理",
            roles: ["crmhetongfanbenguanli"]
          },
          children: []
        }
      ]
    },
    {
      path: "salesSet",
      component: () => import("@/views/crm/salesSet/index"),
      meta: {
        title: "销售结算",
        roles: ["crmxiaoshoujiesuan"]
      },
      alwaysShow: true,
      children: [
        {
          path: "Invoicing",
          component: () => import("@/views/crm/salesSet/Invoicing"),
          name: "开票信息维护",
          meta: {
            title: "开票信息维护",
            roles: ["crmkaipiaoxinxiweihu"]
          },
          children: []
        },
        {
          path: "receivePay",
          component: () => import("@/views/crm/salesSet/receivePay"),
          name: "收款结算管理",
          meta: {
            title: "收款结算管理",
            roles: ["crmshoukuanjiesuanguanli"]
          },
          children: []
        },
        {
          path: "badDebts",
          component: () => import("@/views/crm/salesSet/badDebts"),
          name: "坏账结算管理",
          meta: {
            title: "坏账结算管理",
            roles: ["crmhuaizhangjiesuanguanli"]
          },
          children: []
        },
        {
          path: "InvoicingQuery",
          component: () => import("@/views/crm/salesSet/InvoicingQuery"),
          name: "开票查询",
          meta: {
            title: "开票查询",
            roles: ["crmkaipiaochaxun"]
          },
          children: []
        },
        {
          path: "receivableQuery",
          component: () => import("@/views/crm/salesSet/receivableQuery"),
          name: "垫付应收查询",
          meta: {
            title: "垫付应收查询",
            roles: ["dianfuyingshouchaxun_web"]
          },
          children: []
        }
      ]
    },
    {
      path: "financeMan",
      component: () => import("@/views/crm/financeMan/index"),
      meta: {
        title: "财务管理",
        roles: ["crmcaiwuguanli"]
      },
      alwaysShow: true,
      children: [
        
        // ===========
        {
          path: "reviewBilling",
          component: () => import("@/views/crm/financeMan/reviewBilling"),
          name: "审核开票",
          meta: {
            title: "审核开票",
            roles: ["crmshenhekaipiao"]
          },
          children: []
        },
        {
          path: "register",
          component: () => import("@/views/crm/financeMan/register"),
          name: "回款登记",
          meta: {
            title: "回款登记",
            roles: ["crmhuikuandengji"]
          },
          children: []
        },
        {
          path: "payBack",
          component: () => import("@/views/crm/financeMan/payBack"),
          name: "回款认领",
          meta: {
            title: "回款认领",
            roles: ["crmhuikuanrenling"]
          },
          children: []
        },
        {
          path: "contractSettlementMan",
          component: () => import("@/views/crm/financeMan/contractSettlementMan"),
          name: "合同结算管理",
          meta: {
            title: "合同结算管理",
            roles: ["crmhetongjiesuanguanli"]
          },
          children: []
        },
        ,
        {
          path: "budgetCostRateExport ",
          component: () => import("@/views/costMan/budgetMan/budgetCostRateExport"),
          name: "预算成本率导出",
          meta: {
            title: "预算成本率导出",
            roles: ["yusuanchengbenlvdaochu"]
          }
        },
      ]
    },
    {
      path: "operationMan",
      component: () => import("@/views/crm/operationMan/index"),
      meta: {
        title: "运营管理",
        roles: ["crmyunyingguanli"]
      },
      alwaysShow: true,
      children: [
        {
          path: "researchass",
          component: () => import("@/views/crm/operationMan/researchass"),
          name: "调研指派",
          meta: {
            title: "调研指派",
            roles: ["crmdiaoyanzhipai"]
          },
          children: []
        },
        {
          path: "researchMan",
          component: () => import("@/views/crm/operationMan/researchMan"),
          name: "调研管理",
          meta: {
            title: "调研管理",
            roles: ["crmdiaoyanguanli"]
          },
          children: []
        },
        {
          path: "researchRev",
          component: () => import("@/views/crm/operationMan/researchRev"),
          name: "调研审核",
          meta: {
            title: "调研审核",
            roles: ["crmdiaoyanshenhe"]
          },
          children: []
        },
        {
          path: "researchPlan",
          component: () => import("@/views/crm/operationMan/researchPlan"),
          name: "调研方案",
          meta: {
            title: "调研方案",
            roles: ["crmdiaoyanfangan"]
          },
          children: []
        }
      ]
    }
  ]
};

export default crmRouter;
